import React, { useContext, useEffect, useState } from "react";
import PageContainer from "../../components/PageGeneralContainer/PageGeneralContainer";
import UsersTable from "./UsersTable/UsersTable";
import styles from "./User.module.css";
import {
  getDist,
  getSession,
  getUserCompany,
  getUserType,
} from "../../utils/sessionHandler";
import { toast } from "react-toastify";
import ButtonQ from "../../components/ButtonQ";
import SelectQ from "../../components/FormComponents/SelectQ/SelectQ";
import PageContentLoading from "../../components/PageContentLoading";
import UserForm from "./UserForm/UserForm";
import request from "../../utils/request";
import t from "../../utils/translation";
import LocalizationContext from "../../utils/LocalizationContext";
import { useLocation } from "react-router-dom";
import UserDetail from "./UserDetail/UserDetail";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const emptyUser = {
  name: "",
  lastname: "",
  email: "",
  sectorId: "",
  userType: "",
  id: null,
};

const User = () => {
  const company = getUserCompany();
  const query = useQuery();
  const locale = useContext(LocalizationContext);

  const [loadingContent, setLoadingContent] = useState(true);
  const [loadingData, setLoadingData] = useState(false);
  const [data, setData] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [selectedSector, setSelectedSector] = useState(
    query.get("sectorId") || ""
  );
  const [loading, setloading] = useState(false);
  const [formData, setFormData] = useState(emptyUser);
  const [modal, setModal] = useState(false);
  const [userData, setUserData] = useState({});
  const [showDetail, setShowDetail] = useState(false);


  const userTypes =
    getUserType() === 0
      ? [
          { value: 1, name: "Supervisor" },
          { value: 2, name: "Operator" },
          { value: 4, name: "Connection(Exchange, Exchange+,Exporter)" },
        ]
      : [{ value: 2, name: "Operator" }];

  const getSectors = async () => {
    try {
      const response = await request().get(
        `/api/sector?companyId=${company.Id}`
      );

      setTimeout(() => {
        const sectorOptions = response.data.map((sector) => ({
          value: sector.id,
          name: sector.name,
        }));
        setSectors(sectorOptions);
        setLoadingContent(false);
      }, 250);
    } catch (error) {
      console.error("Error fetching sectors:", error);
    }
  };

  

  useEffect(() => {
    getSectors();
  }, [company.Id]);

  const getUsers = async (sectorId) => {
    setLoadingData(true);

    try {
      const response = await request().get(`/api/appuser?sectorId=${sectorId}`);

      setData(response.data);
    } catch (error) {
      console.error("Error fetching users:", error.response);
    } finally {
      setLoadingData(false);
    }
  };

  const getProfiles = async () => {
    let res = await request().get("/api/Profile/list")
    let format = res.data.map((p) => ({ value: p.id, name: p.name }));
    setProfiles(format)
  }

  useEffect(() => {
    getUsers();
    getProfiles()
  }, [selectedSector]);

  const clearForm = () => {
    setFormData(emptyUser);
  };

  const handleAdd = () => {
    setModal(true);
  };

  const handleClose = () => {
    setModal(false);
    clearForm();
  };

  const handleResetPassword = (user) => {
    setloading(true);
    request()
      .post("/api/appuser/resetpassword", {
        AppUser: user,
        UserLogged: getSession(),
        DistributorId: getDist().id,
      })
      .then((response) => {
        setloading(false);
        toast.success(response.data);
      })
      .catch((error) => {
        console.log(error.response);
        setloading(false);
        toast.error(error.response?.data?.message);
      });
  };

  const handleSector = (e) => {
    const sectorId = e.target.value;
    setFormData((prev) => ({ ...prev, sectorId: sectorId }));
    setSelectedSector(sectorId);
    getUsers(sectorId);
  };

  const handleDetail = (data) => {
    setUserData(data);
    setShowDetail(true);
  };

  const handleCloseDetail = () => {
    setUserData(emptyUser);
    setShowDetail(false);
  };

  if (loadingContent) return <PageContentLoading />;

  return (
    <PageContainer title={t("Title", locale)} category={"user"}>
      <div className={styles.select}>
        <SelectQ
          placeholder={t("SelectASector") || "Select A Sector"}
          value={selectedSector}
          hasPlaceholder={true}
          handleSelect={handleSector}
          options={sectors}
          containerWidth="100%"
        />
      </div>
      {selectedSector && (
        <div className={styles.container}>
          <UsersTable
            users={data}
            getUsers={getUsers}
            handleData={setFormData}
            handleModal={setModal}
            handleDetail={handleDetail}
            selectedSector={selectedSector}
            loading={loading}
            handleResetPassword={handleResetPassword}
          />
          <div className={styles.detailContainer}>
            <ButtonQ
              caption={t("AddButton") || "Add"}
              onClick={() => handleAdd()}
            />
          </div>
        </div>
      )}

      {modal && (
        <UserForm
          formData={formData}
          handleFormData={setFormData}
          handleClose={handleClose}
          open={modal}
          getUsers={getUsers}
          t={t}
          locale={locale}
          sectors={sectors}
          userTypes={userTypes}
          selectedSector={selectedSector}
          profiles={profiles}
        />
      )}

      {showDetail && (
        <UserDetail
          user={userData}
          t={t}
          locale={locale}
          open={handleDetail}
          handleClose={handleCloseDetail}
        />
      )}
    </PageContainer>
  );
};

export default User;
